import { TAppNameEnum, TError, THeartbeatResponseSchema } from '@onesource/schemas';
import { Query, useQuery } from '@tanstack/react-query';

import { axiosServiceInstance } from '../axios';
import { WHO_IS_ONLINE_ENTITY } from './entity';
import { WHO_IS_ONLINE_QUERY_KEYS } from './use-get-all-online-users-query';

type TOptions = {
  appName: TAppNameEnum;
  enabled?: boolean;
  refetchInterval?: number | ((query: Query<THeartbeatResponseSchema, TError>) => number | false | undefined);
  retry?: number;
};

export const useHeartbeatQuery = (options: TOptions) => {
  const { appName, enabled, refetchInterval, retry } = options;

  return useQuery<THeartbeatResponseSchema, TError>({
    queryKey: WHO_IS_ONLINE_QUERY_KEYS.heartbeat(appName),
    queryFn: async () => {
      const res = await axiosServiceInstance.get<THeartbeatResponseSchema>(`/${WHO_IS_ONLINE_ENTITY}/heartbeat`, {
        params: { appName },
      });
      return res.data;
    },
    enabled: enabled ?? true,
    refetchInterval,
    retry: retry ?? 3,
    refetchOnWindowFocus: false,
  });
};
